import React from "react";
import { resolveStageColor } from "./stageColor";

/**
 * Stage color indicator for pills and column headers. Uses the stage's custom
 * color when set, otherwise the index-based theme default.
 */
export default function StageColorDot({ stage, index = 0, className = "" }) {
  const color = resolveStageColor(stage);
  if (color) {
    return (
      <span
        className={`board-pill__dot${className ? ` ${className}` : ""}`}
        style={{ background: color }}
      />
    );
  }
  return (
    <span
      className={`board-pill__dot board-pill__dot--${index % 5}${className ? ` ${className}` : ""}`}
    />
  );
}
